import { largeTabletMax } from '@propertypal/shared/src/constants/mediaQueries';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: flex-start;
  margin: 60px 0;

  @media (${largeTabletMax}) {
    margin: 30px 0;
    flex-direction: column;
  }
`;

export const SummaryBox = styled.div`
  position: relative;
  padding-right: 20px;
  flex: 1;

  // Allows custom colour on favourite icon
  button {
    color: inherit;
  }

  @media (${largeTabletMax}) {
    padding: 0;
    width: 100%;
    margin-top: 15px;
  }
`;

export const KeyDetails = styled.section`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 40px;
  flex-wrap: wrap;

  @media (${largeTabletMax}) {
    max-width: 400px;
  }
`;

export const SummaryItem = styled.div`
  display: flex;
  flex-direction: row;
  margin-right: 15px;
  margin-bottom: 15px;
  align-items: center;

  svg {
    font-size: 36px;
  }
`;
